<template>
  <div
    v-if="component_data"
    class="section-wrapper"
    :style="`background-image: url('${component_data.params.img}')`"
  >
    <div class="preload-bg"></div>

    <div class="dress__box">
      <div id="dress__box__ironing">
        <img :src="`${component_data.params.img_ironed}`" />
        <div id="dress__box__not-ironed">
          <div class="dress__not-ironed-wrapper">
            <img :src="`${component_data.params.img_notironed}`" />
          </div>
          <div id="resize"></div>
        </div>
      </div>
    </div>

    <div class="opened-container d-none d-lg-block">
      <div class="pin__box">
        <div
          v-for="(pin, index) in component_data.params.pins"
          v-bind:key="pin.id"
          @mouseover="pinMouseOver(pin.id)"
          @mouseout="pinMouseOut"
          :style="
            `z-index: ${index}; top: ${pin.top}; left: ${pin.left};right: ${pin.right};`
          "
          :class="['pin', pinClassGenerate(pin.id)]"
        >
          <div class="pin__closed">
            <figure v-if="pin.icon" v-html="pin.icon"></figure>
            <span v-html="pin.pin_title"></span>
          </div>
          <div class="pin__opened">
            <div class="pin__opened__title">
              <figure v-if="pin.icon" v-html="pin.icon"></figure>
              <span v-html="pin.pin_title"></span>
            </div>
            <span class="pin__opened__text" v-html="pin.pin_describe"></span>
          </div>
        </div>
      </div>
    </div>
    <transition name="slide-fade">
      <div class="container-fluid description-box__cnt">
        <div class="row">
          <!--  -->
        </div>
        <div class="row">
          <div
            class="offset-5 col-7 offset-lg-7 col-lg-4 offset-xl-7 col-xl-3 description-box"
          >
            <h3>
              <figure
                v-if="component_data.params.icon"
                v-html="component_data.params.icon"
              ></figure>
              <span v-html="component_data.params.desc_title"></span>
            </h3>
            <p
              class="main-paragraph"
              v-html="component_data.params.desc_main_paragraph"
            ></p>
            <p
              class="sub-paragraph"
              v-html="component_data.params.desc_sub_paragraph"
            ></p>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["component_data"],
  data() {
    return {
      desc_title: "",
      desc_main_paragraph: "",
      desc_sub_paragraph: "",
      icon: "",
      img_ironed: "",
      img_notironed: "",
      m_pos: "",
      resize_el: ""
    };
  },
  methods: {
    resize: function(e) {
      var parent = this.resize_el.parentNode;
      var dx = this.m_pos - e.x;
      this.m_pos = e.x;
      parent.style.width = parseInt(parent.clientWidth) - dx + "px";
    },
    pinMouseOver: function() {
      // this.descIsVisible = true
      // let activePin = this.component_data.params.pins.find(p => {return p.id == id})
      // this.desc_title = activePin.desc_title
      // this.desc_main_paragraph = activePin.desc_main_paragraph
      // this.desc_sub_paragraph = activePin.desc_sub_paragraph
    },
    pinMouseOut: function() {
      // this.descIsVisible = false
    },
    pinClassGenerate: function(id) {
      return "pin-" + id;
    }
  },
  mounted() {
    let cmp = this;
    cmp.resize_el = document.getElementById("resize");
    cmp.resize_el.addEventListener(
      "mousedown",
      function(e) {
        cmp.m_pos = e.x;
        document.addEventListener("mousemove", cmp.resize, false);
      },
      false
    );
    document.addEventListener(
      "mouseup",
      function() {
        document.removeEventListener("mousemove", cmp.resize, false);
      },
      false
    );
  }
};
</script>

<style lang="scss" scoped>
.section-wrapper {
  width: 100vw;
  height: 47.875vw;
  font-family: "Lato", sans-serif;
  background-repeat: no-repeat;
  margin: 80px 0px;
  position: relative;
  background-size: cover;
  background-position: 50% 50%;
  overflow: hidden;
  background-color: rgba(211, 211, 211, 0.555);
  z-index: 1;
  @media only screen and (max-width: 768px) {
    display: none;
  }
  .dress__box {
    position: absolute;
    width: 28vw;
    height: 100%;
    left: 53%;
    transform: translateX(-50%);
    background-color: transparent;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    @media only screen and (max-width: 2000px) {
      left: 49%;
    }
    @media only screen and (max-width: 990px) {
      left: 75%;
      transform: translate(-50%);
    }
    #dress__box__ironing {
      width: 100%;
      position: relative;
      display: flex;
      justify-content: center;
      height: 100%;

      img {
        height: 100%;
        position: absolute;
        max-width: none;
        width: 48vw;
        display: flex;
      }

      > img {
        left: -10vw;
      }
    }
    #dress__box__not-ironed {
      display: flex;
      position: absolute;
      min-width: 8%;
      width: 55%;
      max-width: 102%;
      height: 100%;
      left: 0;
      img {
        left: -10vw;
        height: 100%;
        position: absolute;
        max-width: none;
        width: 48vw;
        display: flex;
      }
    }
    .dress__not-ironed-wrapper {
      overflow: hidden;
      position: relative;
      width: 100%;
    }
    #resize {
      background-color: white;
      position: absolute;
      right: 0;
      width: 5px;
      height: 100%;
      cursor: w-resize;
      outline: none;
      &::before {
        position: absolute;
        top: 50%;
        width: 42px;
        height: 42px;
        margin: -28px 0 0 -19px;
        content: "< >";
        color: #17a3ff;
        font-weight: bold;
        font-size: 18px;
        text-align: center;
        line-height: 42px;
        background: #fff;
        border-radius: 50%;
      }
    }
  }
  .pin__box {
    margin: 0 auto;
    width: 440px;
    height: 750px;
    bottom: 50%;
    transform: translateY(50%);
    right: 8%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    @media only screen and (max-width: 1680px) {
      right: 6%;
    }
    @media only screen and (max-width: 1500px) {
      height: 500px;
      width: 350px;
      right: 5.5%;
    }
    @media only screen and (max-width: 1200px) {
      right: 2%;
    }
    .pin {
      overflow: hidden;
      display: flex;
      left: 0;
      width: 430px;
      height: 70px;
      cursor: pointer;
      font-family: Uni Neue, sans-serif;
      font-size: 26px;
      font-weight: bold;
      flex-grow: 0;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      position: relative;
      transition: all 320ms ease-in-out;
      background: white;
      border-radius: 50px;
      padding-left: 2rem;
      margin: 20px;
      -webkit-box-shadow: 0px 5px 12px -6px rgba(0, 0, 0, 0.35);
      -moz-box-shadow: 0px 5px 12px -6px rgba(0, 0, 0, 0.35);
      box-shadow: 0px 5px 12px -6px rgba(0, 0, 0, 0.35);

      @media only screen and (max-width: 1700px) {
        margin: 10px;
      }
      @media only screen and (max-width: 1500px) {
        width: 330px;
        height: 50px;
        font-size: 18px;
        margin: 5px;
      }
      @media only screen and (max-width: 1500px) {
        width: 320px;
      }
      figure {
        display: inline-block;
        width: 45px;
        height: 45px;
        color: red;
        margin: 0 10px 0 0 !important;

        @media only screen and (max-width: 1500px) {
          width: 30px;
          height: 30px;
        }
      }
      .pin__closed {
        display: flex;
        align-items: center;
      }
      .pin__opened__title {
        display: flex;
        text-align: left;
        font-size: 26px;
        padding-top: 1.2rem;
        padding-left: 5%;
        align-items: center;
        @media only screen and (max-width: 1500px) {
          font-size: 18px;
          padding-left: 5%;
        }
      }
      .pin__opened {
        display: none;
        flex-direction: column;
        width: 100%;
        border-radius: 50px;
        font-size: 16px;

        @media only screen and (max-width: 1500px) {
          font-size: 14px;
        }

        .pin__opened__text {
          display: flex;
          width: 95%;
          line-height: 25px;
          padding: 0.5rem 0.8rem 1.2rem 1.2rem;
          text-align: left;
        }
        span {
          display: inline-block;
        }
      }

      &:hover {
        flex-grow: 2;

        .pin__closed {
          display: none;
        }

        .pin__opened {
          display: flex;
        }
      }
    }
  }
  .btn-open {
    background: #e41429;
    color: #fff;
    position: absolute;
    top: 46%;
    left: 40%;
    padding: 10px 20px;
    border-radius: 99px;
    cursor: pointer;
    border: none;
    text-align: left;

    &:hover,
    &:active,
    &:focus {
      background: darken(#e41429, 5%);
      outline: none;
    }

    svg {
      width: 25px;
      vertical-align: middle;

      .cls-1 {
        fill: none;
        stroke: #fff;
        stroke-miterlimit: 10;
        stroke-width: 60px;
      }
      .cls-2 {
        fill: #fff;
      }
    }

    span {
      display: inline-block;
      vertical-align: middle;
      margin-left: 10px;
      font-size: 14px;
      line-height: 16px;
    }
  }

  .description-box__cnt {
    position: absolute;
    top: 50%;
    left: -49%;
    transform: translateY(-50%);
    pointer-events: none;
    @media only screen and (max-width: 2200px) {
      top: 45%;
    }
    @media only screen and (max-width: 1500px) {
      left: -50%;
      top: 52%;
    }
    @media only screen and (max-width: 1200px) {
      left: -55%;
    }
    @media only screen and (max-width: 990px) {
      left: -42%;
    }
    .description-box {
      color: #fff;
      padding: 40px 60px 30px 60px;
      -webkit-border-top-right-radius: 60px;
      -moz-border-radius-toprught: 60px;
      border-top-right-radius: 60px;

      background: #e41429;
      background: -moz-linear-gradient(left, #e41429 0%, #ae0b11 100%);
      background: -webkit-linear-gradient(left, #e41429 0%, #ae0b11 100%);
      background: linear-gradient(to right, #e41429 0%, #ae0b11 100%);
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e41429', endColorstr='#ae0b11',GradientType=1 );

      @media only screen and (max-width: 1500px) {
        padding: 20px 35px;
      }

      h3 {
        font-size: 38px;
        font-weight: 700;
        margin-bottom: 40px;
        display: flex;
        align-items: center;

        figure {
          width: 80px;
          margin: 0;
          margin-right: 1rem;
        }

        @media only screen and (max-width: 1600px) {
          margin-bottom: 20px;
          font-size: 32px;
        }

        @media only screen and (max-width: 1450px) {
          margin-bottom: 20px;
          font-size: 26px;
        }

        @media only screen and (max-width: 1280px) {
          font-size: 26px;
        }

        @media only screen and (max-width: 1199px) {
          font-size: 22px;
        }
      }

      p.main-paragraph {
        font-size: 18px;
        margin-bottom: 30px;
        line-height: 28px;

        @media only screen and (max-width: 1600px) {
          margin-bottom: 20px;
          font-size: 16px;
          line-height: 24px;
        }

        @media only screen and (max-width: 1450px) {
          margin-bottom: 20px;
          font-size: 14px;
          line-height: 20px;
        }

        @media only screen and (max-width: 1280px) {
        }
      }

      p.sub-paragraph {
        font-size: 18px;
        margin-bottom: 0px;
        font-weight: 300;
        line-height: 28px;
        opacity: 0.9;

        @media only screen and (max-width: 1600px) {
          font-size: 16px;
          line-height: 24px;
        }

        @media only screen and (max-width: 1450px) {
          font-size: 14px;
          line-height: 20px;
        }

        @media only screen and (max-width: 1280px) {
        }
      }
    }
  }

  .preload-bg {
    position: absolute;
    top: -9999px;
    left: -9999px;
    background: url("../../assets/refrigerator_pins_bg_opened.jpg") no-repeat;
  }

  .slide-fade-enter-active {
    transition: all 0.15s ease;
  }
  .slide-fade-leave-active {
    transition: all 0.15s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateY(100px);
    opacity: 0;
  }
}
</style>
